import React from "react";

export const CategoryFive = () => <h1>CategoryFive</h1>
